export default "__VITE_ASSET__3c6a6f23__"